exports.components = {
  "component---src-components-common-page-page-jsx": () => import("./../../../src/components/common/Page/Page.jsx" /* webpackChunkName: "component---src-components-common-page-page-jsx" */),
  "component---src-components-common-post-post-jsx": () => import("./../../../src/components/common/Post/Post.jsx" /* webpackChunkName: "component---src-components-common-post-post-jsx" */)
}

